import React from "react";
import { MdAttachMoney, MdSearch, MdPerson } from "react-icons/md";
import "./RecentActivity.css";

const RecentActivity = ({ recentTransactions = [], recentScans = [] }) => {
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const formatAmount = (amount, currency) => {
    const currencySymbols = {
      usd: "$",
      yen: "¥",
      hkd: "HK$",
      sgd: "S$",
      aud: "AU$",
    };
    
    const symbol = currencySymbols[currency?.toLowerCase()] || currency?.toUpperCase() || "";
    const value = Number(amount).toFixed(2);
    return `${symbol}${value}`;
  };

  return (
    <div className="recent-activity">
      <div className="row">
        {/* Recent Transactions */}
        <div className="col-6">
          <div className="activity-card mb-4">
            <div className="activity-header">
              <h6 className="mb-0 d-flex align-items-center gap-2">
                <MdAttachMoney style={{ color: "#10b981" }} />
                Recent Transactions
              </h6>
            </div>
            <div className="activity-list">
              {recentTransactions.length === 0 ? (
                <div className="no-data">No recent transactions</div>
              ) : (
                recentTransactions.slice(0, 5).map((transaction) => (
                  <div key={transaction._id} className="activity-item">
                    <div className="activity-info">
                      <div className="activity-title">
                        {transaction.userId?.firstName}{" "}
                        {transaction.userId?.lastName}
                      </div>
                      <div className="activity-subtitle">
                        {transaction.planId?.name}
                      </div>
                      <div className="activity-time">
                        {formatDate(transaction.createdAt)}
                      </div>
                    </div>
                    <div className="activity-amount">
                      {formatAmount(transaction.amount, transaction.currency)}
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
        {/* Recent Scans */}
        <div className="col-6">
          <div className="activity-card">
            <div className="activity-header">
              <h6 className="mb-0 d-flex align-items-center gap-2">
                <MdSearch style={{ color: "#3b82f6" }} />
                Recent Scans
              </h6>
            </div>
            <div className="activity-list">
              {recentScans.length === 0 ? (
                <div className="no-data">No recent scans</div>
              ) : (
                recentScans.slice(0, 5).map((scan) => (
                  <div key={scan._id} className="activity-item">
                    <div className="activity-info">
                      <div className="activity-title">{scan.domain}</div>
                      <div className="activity-subtitle">
                        by {scan.userId?.firstName} {scan.userId?.lastName}
                      </div>
                      <div className="activity-time">
                        {formatDate(scan.createdAt)}
                      </div>
                    </div>
                    <div className="activity-icon">
                      <MdPerson style={{ color: "#6b7280" }} />
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecentActivity;
